export const sensorIgnoredText = "--";